/* src/app/common/components/menu-item-mappings/menu-item-mappings.component.scss */
.toolbar-container ion-toolbar {
  --background: transparent;
  --min-height: auto;
}
.toolbar-container ion-toolbar ion-title {
  padding: 0;
  font-size: 28px;
  font-weight: 500;
}
.toolbar-container ion-toolbar .actions {
  margin-right: -0.5rem;
}
.toolbar-container ion-toolbar .actions > ion-button,
.toolbar-container ion-toolbar .actions > app-button-group {
  margin: 0 0.5rem;
}
:host {
  display: block;
}
section.mappings-container.row {
  --bs-gutter-x: 0;
  --bs-gutter-y: 0;
  padding: 0.5rem;
}
section.mappings-container.row > .col {
  padding: 1rem;
}
ion-card {
  margin: 0;
  border-radius: var(--card-border-radius, 0);
  box-shadow: none;
  border: 1px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.1s ease-in-out 0.25s;
  min-width: 200px;
  max-width: 431px;
}
ion-card:focus-within,
ion-card:hover {
  border-color: rgba(0, 0, 0, 0.13);
}
ion-card .thumbnail {
  height: 100px;
  max-height: 100px;
  overflow: hidden;
  background-image: url(https://ionicframework.com/docs/demos/api/thumbnail/thumbnail.svg);
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  background-size: cover;
  position: relative;
}
ion-card .thumbnail app-food-type-indicator {
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
}
ion-card ion-card-header {
  padding: 0;
}
ion-card ion-card-header .title-container {
  margin-bottom: -18px;
}
ion-card ion-card-header ion-card-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
ion-card .tags > * {
  display: inline-block;
  vertical-align: middle;
  padding: 0 2px;
}
ion-card ion-card-content {
  padding: 0;
  padding-top: 0.25rem;
}
ion-card ion-card-content > * {
  padding: 0.25rem 0;
}
ion-card ion-card-content .dashboard {
  border: 1px solid red;
}
.card-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.card-button {
  border: none;
  outline: 0;
  padding: 8px;
  color: white;
  background-color: #000;
  text-align: center;
  cursor: pointer;
  width: 100%;
  font-size: 18px;
}
.color-dark {
  color: var(--ion-color-dark);
}
.color-danger {
  color: var(--ion-color-danger);
}
.price button,
.stock button {
  padding: 0;
  background-color: transparent;
  display: block;
  width: 100%;
  text-align: left;
  font-size: 1rem;
}
.price button:focus-visible,
.price button:focus,
.price button:hover,
.stock button:focus-visible,
.stock button:focus,
.stock button:hover {
  outline: 0;
}
.price button:hover ion-icon.edit-icon,
.price button:focus ion-icon.edit-icon,
.stock button:hover ion-icon.edit-icon,
.stock button:focus ion-icon.edit-icon {
  display: inline-block;
  color: #737373;
}
.price.no-pointer,
.stock.no-pointer {
  cursor: default;
}
.price ion-icon.edit-icon,
.stock ion-icon.edit-icon {
  vertical-align: top;
  margin-left: 4px;
  display: none;
}
.price .amount {
  font-size: 16px;
}
/*# sourceMappingURL=menu-item-mappings.component.css.map */
